import { render, staticRenderFns } from "./DateSectionComponent.vue?vue&type=template&id=395b4e55&scoped=true"
import script from "./DateSectionComponent.js?vue&type=script&lang=js&external"
export * from "./DateSectionComponent.js?vue&type=script&lang=js&external"
import style1 from "./DateSectionComponent.vue?vue&type=style&index=1&id=395b4e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b4e55",
  null
  
)

export default component.exports